
import Env from '../base/env.js';
import Channels from '../base/channels.js';
import 'scroll-restoration-polyfill';
import MainnavTouch from '../ui/mainnav-touch.js'
import UISwitcher from '../ui/UIswitcher'
import Launcher from '../components/launcher/Launcher'
import Barba from 'barba.js'

class UI
{
    constructor()
    {
        history.scrollRestoration = 'manual';
        this.resetEnv();
        this.launcher = new Launcher()
        Env.framework.mainnav = new MainnavTouch()
        this.uiSwitch =  new UISwitcher()
        this.updateMainnavActive({url: window.location.href , namespace: Env.framework.toolbox.getController() })
    }

    launchAfter()
    {
        const $item = Env.$master.querySelector('.barba-container .single-next')
        if($item != null && Env.enteringNext == false)
        {
            const getUrl = $item.querySelector('.jsScrollNext--link').getAttribute('data-href')
            Env.enteringNext = true
            Barba.Pjax.goTo(getUrl)
        }
    }

    resetEnv()
    {
        Channels.on('statechange::before',function()
        {

        })
        Channels.on('statechange::ready',(current,old,container)=>
        {
            Env.$html.classList.remove('skin--isWhite')
            Env.$html.classList.remove('skin--isDark')
            Env.$html.classList.remove('skin--bottomIsWhite')
            Env.$html.classList.remove('cover--isHidden')
            Env.$html.classList.remove('introduction--isHidden')
            Env.$body.classList.remove('cursor-disabled')
            this.updateMainnavActive(current)
        })
        Channels.on('statechange::finalize',function()
        {
            Env.enteringNext = false
        })
    }

    updateMainnavActive(context)
    {
        if(window.location.hash.length > 0)
        {
            context.url = window.location.href.split('#')[0]
        }
        for(let item of Env.$menuListeners) {
            const href = item.getAttribute('href')
            if(href == context.url) {
                item.parentElement.classList.add('is--active')
            } else {
                item.parentElement.classList.remove('is--active')
            }
        }
    }

}

export default UI;